import React from 'react';

import { CircularProgress } from '@mui/material';
import { CustomizedBackdrop } from 'shared/components/PageLoader/styled';

function PageLoader() {
  return (
    <CustomizedBackdrop open>
      <CircularProgress color="inherit" />
    </CustomizedBackdrop>
  );
}

export default PageLoader;
